function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 0A1.5 1.5 0 000 1.5v2A1.5 1.5 0 001.5 5h2A1.5 1.5 0 005 3.5v-2A1.5 1.5 0 003.5 0h-2zM1 1.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2zM8.5 0A1.5 1.5 0 007 1.5v2A1.5 1.5 0 008.5 5h2A1.5 1.5 0 0012 3.5v-2A1.5 1.5 0 0010.5 0h-2zM8 1.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2zm-8 7A1.5 1.5 0 011.5 7h2A1.5 1.5 0 015 8.5v2A1.5 1.5 0 013.5 12h-2A1.5 1.5 0 010 10.5v-2zM1.5 8a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2zm7-1A1.5 1.5 0 007 8.5v2A1.5 1.5 0 008.5 12h2a1.5 1.5 0 001.5-1.5v-2A1.5 1.5 0 0010.5 7h-2zM8 8.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2z"
});

function SvgCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCategory;